var Tag = /** @class */ (function () {
    function Tag(tag) {
        var _this = this;
        this.executeSafely = function () {
            try {
                _this._tag();
            }
            catch (e) {
                console.error("Error executing tag", e);
            }
        };
        this._tag = tag;
    }
    return Tag;
}());
export { Tag };
